import http from "./http.js";

export default {
  userGet(payload) {
    return http.get(`/userget/${payload.action}/${payload.id}`);
  },
  userPost(payload) {
    return http.post("/userpost", { payload });
  },
  bestellungPost(payload) {
    return http.post("/bestellungpost", { payload });
  },
  bestellungGet(payload) {
    return http.get(`/bestellungget/${payload.action}/${payload.id}`);
  },
  webinarePost(payload) {
    return http.post("/webinarepost", { payload });
  },
  webinareGet(payload) {
    // optionaler Sicherheits-Code (Einladungs-Links) als Query-Parameter
    const code = payload.code ? `?code=${Number(payload.code)}` : "";
    return http.get(`/webinareget/${payload.action}/${payload.id}${code}`);
  },
  mixedPost(payload) {
    return http.post("/mixedpost", { payload });
  },
  mixedGet(payload) {
    return http.get(`/mixedget/${payload.action}/${payload.id}`);
  },
};
 